import React, { useEffect, useState } from "react";

const triedOptions = [
    {
        value: "Tried prescription(s)",
        label: "You've used prescription medications (topical or oral)",
    },
    {
        value: "Tried something else (over-the-counter drug, diet changes, other)",
        label: "OTC products, home remedies, diet/lifestyle changes, etc.",
    },
    {
        value: "I haven't tried anything",
        label: "No treatments tried yet",
    },
];

const TriedQuestion = ({ onSubmit, onNext, initialValue, ensureFullyVisible }) => {
    const [selected, setSelected] = useState([]);

    // Pre-fill when editing
    useEffect(() => {
        if (Array.isArray(initialValue)) {
            setSelected(initialValue);
        }
    }, [initialValue]);

    const toggle = (value) => {
        setSelected((prev) => {
            if (value === "I haven't tried anything") {
                const next = prev.includes(value) ? [] : [value];
                queueMicrotask(() => ensureFullyVisible?.());
                return next;
            }
            const base = prev.filter((x) => x !== "I haven't tried anything");
            const next = base.includes(value) ? base.filter((x) => x !== value) : [...base, value];
            queueMicrotask(() => ensureFullyVisible?.());
            return next;
        });
    };

    // Also nudge after the state has painted (mobile keyboards/layout shifts)
    useEffect(() => {
        if (selected.length) {
            const t = setTimeout(() => ensureFullyVisible?.(), 120);
            return () => clearTimeout(t);
        }
    }, [selected, ensureFullyVisible]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selected.length === 0) return;
        onSubmit(selected);
        onNext();
        setSelected([]);
    };

    const canSubmit = selected.length > 0;

    return (
        <form onSubmit={handleSubmit} className="input-form">
            <div className="menstrual-cycle-options-container">
                <div className="menstrual-cycle-options">
                    {triedOptions.map((opt) => {
                        const isSelected = selected.includes(opt.value);
                        return (
                            <button
                                key={opt.value}
                                type="button"
                                className={`menstrual-cycle-button ${isSelected ? "menstrual-cycle-button-selected" : ""}`}
                                onClick={() => toggle(opt.value)}
                                aria-pressed={isSelected}
                            >
                                <div className="option-content">
                                    <div className="option-value">{opt.value}</div>
                                    <div className="option-description">{opt.label}</div>
                                </div>
                            </button>
                        );
                    })}
                </div>

                <button
                    type="submit"
                    className="menstrual-cycle-submit-button"
                    disabled={!canSubmit}
                    onFocus={() => ensureFullyVisible?.()}
                >
                    Continue
                </button>
            </div>
        </form>
    );
};

export default TriedQuestion;
